import Vue from 'vue';
import {Howl, Howler} from 'howler';

Vue.component('sound-component', {
    props: {
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            soundfiles: null,
            currentlyPlaying: [],
        };
    },

    watch: {
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

        this.init()

        EventBus.$on('play-sound', (sound) => {
            console.log('eventbus is called: ', sound)
            this.playThisSound(sound)
        });

        EventBus.$on('fadeout-sound', (sound) => {
            console.log('fadeout eventbus is called: ', sound)
            this.fadeoutSound(sound)
        });

        EventBus.$on('stop-sound', (sound) => {
            console.log('Stop eventbus is called: ', sound)
            this.stopSound(sound)
        });

        EventBus.$on('audio:stop-all', () => {
            console.log('Stopping all sound!');
            this.fadeoutSound(this.currentlyPlaying);
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        init() {
            Howler.unload();
            this.soundfiles = {
                menu01 : new Howl({
                    src: ['/media/audio/Menu/01_MUZIEK.mp3'],
                    loop: true,
                }),
                verhaal1M02 : new Howl({
                    src: ['/media/audio/Verhaal-1/02_MUZIEK.mp3'],
                    loop: true,
                    volume: 0.5,
                }),
                verhaal1T03 : new Howl({
                    src: ['/media/audio/Verhaal-1/03_TEXTURE.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal1BrandA : new Howl({
                    src: ['/media/audio/Verhaal-1/04-A_BRAND.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal1OneshotSireneB : new Howl({
                    src: ['/media/audio/Verhaal-1/04-B_SIRENE.mp3'],
                    loop: false,
                    volume: 0.5,
                }),
                verhaal1T06 : new Howl({
                    src: ['/media/audio/Verhaal-1/06_TEXTURE.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal1OneshotDeur : new Howl({
                    src: ['/media/audio/Verhaal-1/07_DEUR+MOMPEL+LOPEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal1OneshotRaam : new Howl({
                    src: ['/media/audio/Verhaal-1/08_RAAM.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal1OneshotOntbijt : new Howl({
                    src: ['/media/audio/Verhaal-1/09_ONTBIJTTAFEL.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal1M10 : new Howl({
                    src: ['/media/audio/Verhaal-1/10_MUZIEK.mp3'],
                    loop: true,
                    volume: 0.5,
                }),
                verhaal1OneshotWinkelbel : new Howl({
                    src: ['/media/audio/Verhaal-1/11_WINKELBEL.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal1OneshotVoetstappen : new Howl({
                    src: ['/media/audio/Verhaal-1/12_VOETSTAPPEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal1OneshotWrijven : new Howl({
                    src: ['/media/audio/Verhaal-1/13_WRIJVEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal1OneshotAutodeur : new Howl({
                    src: ['/media/audio/Verhaal-1/14_AUTODEUR.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal1OneshotAutostart : new Howl({
                    src: ['/media/audio/Verhaal-1/15_AUTO_START.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal1TAuto : new Howl({
                    src: ['/media/audio/Verhaal-1/16_AUTO.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal2MAuto : new Howl({
                    src: ['/media/audio/Verhaal-2/16_MUZIEK_AUTO.mp3'],
                    loop: true,
                    volume: 0.5,
                }),
                verhaal2TAuto : new Howl({
                    src: ['/media/audio/Verhaal-2/17_AUTO.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal2OneshotBocht : new Howl({
                    src: ['/media/audio/Verhaal-2/18_BOCHT.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal2M19 : new Howl({
                    src: ['/media/audio/Verhaal-2/19_MUZIEK.mp3'],
                    loop: true,
                    volume: 0.3,
                }),
                verhaal2OneshotAutoUitzetten : new Howl({
                    src: ['/media/audio/Verhaal-2/20_AUTO_UITZETTEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal2OneshotDeurpiep : new Howl({
                    src: ['/media/audio/Verhaal-2/21_SLOT+LOPEN+DEURPIEP.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal2OneshotTrapVoetstappen : new Howl({
                    src: ['/media/audio/Verhaal-2/22_TRAP_VOETSTAPPEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal2OneshotGangVoetstappen : new Howl({
                    src: ['/media/audio/Verhaal-2/23_GANG_VOETSTAPPEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal2OneshotDeurpiep2 : new Howl({
                    src: ['/media/audio/Verhaal-2/24_DEURPIEP.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal3M25 : new Howl({
                    src: ['/media/audio/Verhaal-3/25_MUZIEK.mp3'],
                    loop: true,
                    volume: 0.5,
                }),
                verhaal3T26 : new Howl({
                    src: ['/media/audio/Verhaal-3/26_TEXTURE.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal3OneshotOntbijttafel : new Howl({
                    src: ['/media/audio/Verhaal-3/27_ONTBIJTTAFEL+GAAP.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal3OneshotBordKnorren : new Howl({
                    src: ['/media/audio/Verhaal-3/28_BORD+KNORREN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal3OneshotVegen : new Howl({
                    src: ['/media/audio/Verhaal-3/29_VEGEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal3T30 : new Howl({
                    src: ['/media/audio/Verhaal-3/30_TEXTURE.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal3OneshotGiechelen : new Howl({
                    src: ['/media/audio/Verhaal-3/31_GIECHELEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal3TDouche : new Howl({
                    src: ['/media/audio/Verhaal-3/32_DOUCHE.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal3OneshotWinkelbel : new Howl({
                    src: ['/media/audio/Verhaal-3/33_WINKELBEL.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal3OneshotMompel : new Howl({
                    src: ['/media/audio/Verhaal-3/34_MOMPEL.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal3OneshotKassa : new Howl({
                    src: ['/media/audio/Verhaal-3/35_KASSA+INPAKKEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4T36 : new Howl({
                    src: ['/media/audio/Verhaal-4/36_TEXTURE.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal4TBrand : new Howl({
                    src: ['/media/audio/Verhaal-4/37_BRAND.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal4OneshotTekenen : new Howl({
                    src: ['/media/audio/Verhaal-4/38_MOMPEL+LA+TEKENEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4OneshotBel : new Howl({
                    src: ['/media/audio/Verhaal-4/39_BEL+STOELEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4T40 : new Howl({
                    src: ['/media/audio/Verhaal-4/40_TEXTURE.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal4OneshotHond : new Howl({
                    src: ['/media/audio/Verhaal-4/41-A_HOND.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4OneshotKat : new Howl({
                    src: ['/media/audio/Verhaal-4/41-B_KAT.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4OneshotEzel : new Howl({
                    src: ['/media/audio/Verhaal-4/42_EZEL+GIECHEL.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4OneshotBlaadjes : new Howl({
                    src: ['/media/audio/Verhaal-4/43_BLAADJES.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4OneshotKnippen : new Howl({
                    src: ['/media/audio/Verhaal-4/44_KNIPPEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4OneshotMompel : new Howl({
                    src: ['/media/audio/Verhaal-4/45_MOMPEL.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4OneshotBladeren : new Howl({
                    src: ['/media/audio/Verhaal-4/46_BLADEREN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4OneshotGiechel: new Howl({
                    src: ['/media/audio/Verhaal-4/47_GIECHELMOMPEL.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal4OneshotWegrennen: new Howl({
                    src: ['/media/audio/Verhaal-4/48_WEGRENNEN+DEUR.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal5TBrand : new Howl({
                    src: ['/media/audio/Verhaal-5/49_BRAND.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal5T50 : new Howl({
                    src: ['/media/audio/Verhaal-5/50_TEXTURE.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal5OneshotDeur: new Howl({
                    src: ['/media/audio/Verhaal-5/51_DEUR+ZITTEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal5OneshotTrap: new Howl({
                    src: ['/media/audio/Verhaal-5/52_TRAP.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal5OneshotKus: new Howl({
                    src: ['/media/audio/Verhaal-5/53_KUS.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal5OneshotMompel: new Howl({
                    src: ['/media/audio/Verhaal-5/54_MOMPEL_JA.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal5OneshotRuiken: new Howl({
                    src: ['/media/audio/Verhaal-5/55_RUIKEN.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal5TTosti : new Howl({
                    src: ['/media/audio/Verhaal-5/56_TOSTI.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal5TBrandmelder : new Howl({
                    src: ['/media/audio/Verhaal-5/57_BRANDMELDER.mp3'],
                    loop: true,
                    volume: 1,
                }),
                verhaal5OneshotKnopje: new Howl({
                    src: ['/media/audio/Verhaal-5/58_KNOPJE+ZUCHT.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal5OneshotVuilnisbak: new Howl({
                    src: ['/media/audio/Verhaal-5/59_LACHEN+VUILNISBAK.mp3'],
                    loop: false,
                    volume: 1,
                }),
                verhaal5OneshotLakens: new Howl({
                    src: ['/media/audio/Verhaal-5/60_LAKENS.mp3'],
                    loop: false,
                    volume: 1,
                }),
            };
        },
        playThisSound(val) {
            val.forEach(element => {
                if (!this.soundfiles[element].playing()) {
                    console.log('play sound element: ', element)
                    this.soundfiles[element].play();
                    this.currentlyPlaying.push(element);
                }
            })
        },
        fadeoutSound(val) {
            val.forEach(element => {
                const currentVolume = this.soundfiles[element].volume();
                this.soundfiles[element].fade(currentVolume, 0, 1200);

               // Clear listener after first call.
               this.soundfiles[element].once('fade', (val) => {
                    this.soundfiles[element].stop();
                    this.soundfiles[element].volume(currentVolume);
                });
            });
        },
        stopSound(val) {
            function arrayRemove(arr, value) { 
    
                return arr.filter(function(ele){ 
                    return ele != value; 
                });
            }
            

            val.forEach(element => {
                this.soundfiles[element].stop();
                this.currentlyPlaying = arrayRemove(this.currentlyPlaying, element);
                this.currentlyPlaying.push(element);
            });
        }
    },

    beforeDestroy() {
        EventBus.$off('play-sound');
        EventBus.$off('fadeout-sound');
        EventBus.$off('stop-sound');
        EventBus.$off('audio:stop-all');
    }
});
